import * as React from 'react';
import { Route } from 'react-router';
import { Router } from './Router';
import { ConnectedRouter } from 'connected-react-router';
import { History } from 'history';
import { Dispatch, Store } from 'redux';
import { IApplicationState } from '../Store';
import { connect, Provider } from 'react-redux';

import { setLocale } from '../Store/I18n/Actions';
import { Locales } from '../Store/I18n/Constants';
import { IUserState } from '../Store/User/Types';
import { TypedStorage } from '../Utils/TypedStorage';
import { IDashboardState } from '../Store/Dashboard/Types';
import { getPoliticalGroup } from "../Store/Dashboard/Actions";
import { IAuthorizedMedia, ISearchState } from '../Store/Search/Types';
import { getProgramTypes, getProgramEditors, getMediasSource, getElectionCampaign } from '../Store/Search/Actions';
import { getTokenPlayer, getAuthorizedMediasSuccess, getAuthorizedMedias } from '../Store/User/Actions';
import { getTheme } from '../Themes';
import { ThemeProvider } from '@material-ui/core/styles';
import { ILayoutState } from '../Store/Layout/Types';
import { getCircoList, getDetailEtudeIds, getStudyTypes } from '../Store/Elections/Actions';
import { IElectionsState, IElectionsStudyFilters } from '../Store/Elections/Types';
import { getCurrentEtude } from '../Store/Elections/Reducer';
import { getPoliticalRegime } from "../Store/PoliticalRegime/Actions";

interface IPropsFromDispatch {
  getPoliticalRegime: typeof getPoliticalRegime;
  getPoliticalGroup: typeof getPoliticalGroup;
  getAuthorizedMedias: typeof getAuthorizedMedias;
  getAuthorizedMediasSuccess: typeof getAuthorizedMediasSuccess;
  getProgramTypes: typeof getProgramTypes;
  getProgramEditors: typeof getProgramEditors;
  getTokenPlayer: typeof getTokenPlayer;
  getMediasSource: typeof getMediasSource;
  getStudyTypes: typeof getStudyTypes;
  getCircoList: typeof getCircoList;
  getDetailEtudeIds: typeof getDetailEtudeIds;
  getElectionCampaign: typeof getElectionCampaign;
}

interface IPropsFromState {
  user: IUserState,
  dashboard: IDashboardState,
  search: ISearchState,
  layout: ILayoutState,
  elections: IElectionsState,
}

interface IOwnProps {
  store: Store<IApplicationState>;
  history: History;
}

type AllProps = IPropsFromState & IPropsFromDispatch & IOwnProps;


class MainComponent extends React.Component<AllProps> {

  public componentDidMount() {
    if (this.props.dashboard.politicalRegimeList.length === 0 && TypedStorage.get('userToken','') !== '') {
      this.props.getPoliticalRegime(TypedStorage.get('userToken',''));
    }
    if (this.props.dashboard.politicalGroupList.length === 0 && TypedStorage.get('userToken','') !== '') {
      this.props.getPoliticalGroup(TypedStorage.get('userToken',''));
    }
    if (this.props.user.medias.length === 0 && TypedStorage.get('userToken','') !== '') {
      let medias:any[] = []
      if (TypedStorage.get('medias','') !== '') {
        medias = JSON.parse(TypedStorage.get('medias',''));
      }
      if (medias.length === 0) {
        this.props.getAuthorizedMedias(TypedStorage.get('userToken',''));
      } else {
        let mediasID:number[] = medias.map((x:any)=>{
          return x.id || x.media_id
        })
        if (mediasID.length > 0) {
          this.props.getMediasSource(mediasID);
          if (TypedStorage.get('medias','') !== "") {
            this.props.getAuthorizedMediasSuccess(JSON.parse(TypedStorage.get('medias','')));
          }
        }
      }
    }
    if (this.props.search.programTypes.length === 0 && TypedStorage.get('userToken','') !== '') {
      this.props.getProgramTypes(TypedStorage.get('userToken',''));
      this.props.getElectionCampaign()
    }
    if (this.props.search.programEditors.length === 0 && TypedStorage.get('userToken','') !== '') {
      this.props.getProgramEditors(TypedStorage.get('userToken',''));
    }
    if (this.props.user.tokenPlayer === '' && TypedStorage.get('userName','') !== '') {
      this.props.getTokenPlayer(true, true, TypedStorage.get('userName',''))
    }
    if (this.props.elections.elections_study_types.length === 0 && TypedStorage.get('userToken','') !== '') {
      this.props.getStudyTypes();
    }
    if (this.props.elections.circonscriptions.length === 0 && this.props.elections.elections_study_types.length > 0 && TypedStorage.get('userToken','') !== '') {
      this.props.getCircoList(this.props.elections.isElectionChecked ? getCurrentEtude(this.props.elections.elections_study_types).id : 24, false, this.props.user.allMediasID)
    }
  }

  public render() {
    const { store, history } = this.props;
    return (
      <ThemeProvider theme={getTheme(this.props.layout.theme)}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Route component={Router} />
          </ConnectedRouter>
        </Provider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ user, dashboard, search, layout, elections }: IApplicationState) => ({
  user, dashboard, search, layout, elections
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loadI18n: (locale: Locales) => dispatch(setLocale(locale)),
  getPoliticalRegime: (token: string) => dispatch(getPoliticalRegime(token)),
  getPoliticalGroup: (token: string) => dispatch(getPoliticalGroup(token)),
  getAuthorizedMedias: (token:string) => dispatch(getAuthorizedMedias(token)),
  getAuthorizedMediasSuccess: (medias: IAuthorizedMedia[]) => dispatch(getAuthorizedMediasSuccess(medias)),
  getProgramTypes: (token: string) => dispatch(getProgramTypes(token)),
  getElectionCampaign: () => dispatch(getElectionCampaign()),
  getProgramEditors: (token: string) => dispatch(getProgramEditors(token)),  
  getTokenPlayer : (music:boolean, readjusted:boolean,userName:string) => dispatch(getTokenPlayer(music, readjusted, userName)),
  getMediasSource: (mediasIDs:number[]) => dispatch(getMediasSource(mediasIDs)),
  getStudyTypes: (filters?:IElectionsStudyFilters) => dispatch(getStudyTypes(filters)),
  getCircoList: (study_type_id: number, is_nat:boolean,mediasIDs:number[]) => dispatch(getCircoList(study_type_id, is_nat, mediasIDs)),
  getDetailEtudeIds: (study_type_id:number) => dispatch(getDetailEtudeIds(study_type_id))
});

const Main = connect<IPropsFromState, IPropsFromDispatch, IOwnProps, IApplicationState>
(mapStateToProps, mapDispatchToProps)(MainComponent);

export { Main };
